// removed by extract-text-webpack-plugin
module.exports = {"strike":"Strike__strike___28OW3","strikeContent":"Strike__strikeContent___1hd4F"};


//////////////////
// WEBPACK FOOTER
// ./src/Strike.css
// module id = 10
// module chunks = 0 1